import ApiService from '../../../util/api';
import featureFlags from '../../../util/featureFlags';
import ActionTypes from '../projectActionTypes';

// Selectors
import { getProjectUUID } from '../../selectors/cardProjectSelector';

function requestAddProjectToCart() {
  return {
    type: ActionTypes.REQUEST_ADD_PROJECT_TO_CART,
  };
}

function receiveAddProjectToCart() {
  return {
    type: ActionTypes.RECEIVE_ADD_PROJECT_TO_CART,
  };
}

// function that handles using v1 endpoint for projects with old sku model or v3 endpoint
// for projects with new sku model - with this action conditional logic doesnt have to be
// implemented in components
export function addProjectToCart(isCustomizable = true) {
  return (dispatch, getState) => {
    const state = getState();
    const projectUUID = getProjectUUID(state);
    const requestBody = {
      projectUUID,
    };
    dispatch(requestAddProjectToCart());
    const version = featureFlags.get('newCardAddToCart') ? 'v4' : 'v3';
    return ApiService.post(`/web-api/${version}/card-project/cart`, requestBody, {}, {}, 'text')
      .then(() => dispatch(receiveAddProjectToCart()))
      .then(() => {
        if (isCustomizable) {
          window.location = `/wedding-planning/cart/${projectUUID}/confirmation`;
        } else {
          window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
        }
      });
  };
}

export const quickAddProjectToCart = projectUUID => {
  return dispatch => {
    if (!projectUUID) return Promise.resolve(null);

    const requestBody = {
      projectUUID,
    };
    dispatch(requestAddProjectToCart());
    const version = featureFlags.get('newCardAddToCart') ? 'v4' : 'v3';
    return ApiService.post(`/web-api/${version}/card-project/cart`, requestBody, {}, {}, 'text')
      .then(() => dispatch(receiveAddProjectToCart()))
      .then(() => {
        window.dispatchEvent(new CustomEvent('OPEN_MODAL_EVENT', { detail: 'CART' }));
      });
  };
};
